import { Tooltip, Position } from "evergreen-ui"
import Figure from "./figure"

const neuronImage = (layer, neuron) =>
  `https://storage.googleapis.com/fls/nickc/neuron_renders/${layer}_${neuron}.jpg`

export default class Synthetic1 extends Component {
  render() {
    const { data } = this.props
    const neurons = [379, 406, 385, 343, 342, 388, 324, 340, 330, 349]
    const neuronWidth = 89
    const responseWidth = window.innerWidth / 4 - neuronWidth / 4 - 30

    return (
      <Figure>
        <Surface alignSelf="center">
          <Surface flexFlow="row">
            <Surface marginX={3} marginTop={neuronWidth + 7}>
              {neurons.map(neuron => (
                <Surface>
                  <div>
                    <img
                      style={{ borderRadius: 5 }}
                      width={neuronWidth}
                      marginRight={10}
                      src={neuronImage("mixed3b", neuron)}
                    />
                  </div>
                </Surface>
              ))}
            </Surface>

            {[true, false].map(edge =>
              [true, false].map(invert => {
                const { curves, ...obj } = data[`edge:${edge}-invert:${invert}`]

                return (
                  <Surface marginX={3}>
                    <div>
                      <img
                        style={{ borderRadius: 5 }}
                        width={responseWidth}
                        height={neuronWidth}
                        src={curves}
                      />
                    </div>
                    {neurons.map(neuron => (
                      <div>
                        <img
                          style={{ borderRadius: 5 }}
                          height={neuronWidth}
                          width={responseWidth}
                          src={obj[neuron]}
                        />
                      </div>
                    ))}
                  </Surface>
                )
              }),
            )}
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
